// import PropTypes from 'prop-types';
import {PureComponent} from 'react';
import ContentWrapper from 'Component/ContentWrapper';
import CategoryPagination from 'Component/CategoryPagination';
import Html from "Component/Html";

import './Events.style';
import EventsBlogPostCard from "./EventsBlogPostCard";
import {BLOG_CATEGORY_LISTING} from "../../../route/CategoryListing/CategoryListing.config";

export class Events extends PureComponent {
    static propTypes = {
        // TODO: implement prop-types
    };

    componentDidMount() {
        this.updateMeta();
        this.setHeaderState();
        this.updateBreadcrumbs();
    }

    updateBreadcrumbs() {
        const {updateBreadcrumbs, mfblog_permalink_route, categoryObject : { title }, blog_title } = this.props;
        const breadcrumbs = [
            {
                url: window.location.pathname,
                name: title
            },
            {
                url: `/${mfblog_permalink_route}`,
                name: blog_title
            }
        ];

        updateBreadcrumbs(breadcrumbs);
    }

    updateMeta() {
        const {updateMeta, redirect_code_previous, categoryObject : _category} = this.props;


        updateMeta({
            title: _category.title,
            meta_title : _category.meta_title,
            meta_keywords : _category.meta_keywords,
            meta_description : _category.meta_description,
            canonical_url: window.location.href,
            redirect_from: window.location.pathname,
            redirect_code_previous
        });
    }

    getCanonicalUrl() {
        return window.location.href;
    }

    setHeaderState() {
        const {setHeaderState, history} = this.props;
        setHeaderState({
            name: BLOG_CATEGORY_LISTING,
            title: 'Blog',
            onBackClick: () => history.goBack()
        });
    }

    renderTitle() {
        const {categoryObject: {title}} = this.props;

        return (
            <h1 block="CategoryListing" elem="Title">
                {title}
            </h1>
        );
    }

    getCategoryDescription() {
        const {categoryObject: {content}} = this.props;

        if (!content)
            return null;

        return (
            <div className="CategoryListing-Description">
                <Html content={content}/>
            </div>
        );
    }

    renderLatestPost() {
        const {
            isLoaded,
            posts: {items},
            pageSize
        } = this.props;

        if (isLoaded && items.length) {
            return (
                <div className="Events_LatestPost">
                    <EventsBlogPostCard
                        key={items[0].post_id}
                        block="BlogPostCard"
                        post={items[0]}
                        topFirstEvents={true}
                        serialNumber={0}
                    />
                </div>
            );
        }

        if (isLoaded) {
            return null;
        }

        return Array.from({length: 1}, (_, i) => (
            <EventsBlogPostCard
                key={i}
                block="BlogPostCard"
                isPlaceholder
            />
        ));
    }

    renderGrid() {
        const {
            isLoaded,
            posts: {items},
            pageSize
        } = this.props;

        if (isLoaded && items.length) {
            return items.map((post, index) => (
                <EventsBlogPostCard
                    key={post.post_id}
                    block="BlogPostCard"
                    post={post}
                    serialNumber={index}
                />
            ));
        }

        if (isLoaded) {
            return (
                <span>
                    {__('No posts in this category')}
                </span>
            );
        }

        return Array.from({length: pageSize}, (_, i) => (
            <EventsBlogPostCard
                key={i}
                block="BlogPostCard"
                isPlaceholder
            />
        ));
    }

    renderPagination() {
        const {
            isLoading,
            posts: {
                total_pages: totalPages
            },
            requestPage
        } = this.props;

        return (
            <CategoryPagination
                isLoading={isLoading}
                totalPages={totalPages}
                onPageSelect={()=>{requestPage()}}
            />
        );
    }

    render() {
        return (
            <main block="Events">
                <ContentWrapper label="Events">
                    {this.renderTitle()}
                    {this.getCategoryDescription()}
                    {this.renderLatestPost()}
                    <div block="Events" elem="Grid">
                        {this.renderGrid()}
                        {this.renderPagination()}
                    </div>
                </ContentWrapper>
            </main>
        );
    }
}

export default Events;
